<div id="bg_app_loader">
    <img src="assets/images/loading-gif.gif" alt="#" width="75px" height="75px"/>
</div>